import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Container,Row } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import FadeIn from 'react-fade-in';

import styled from "styled-components"; 
 
import PageTitle from "./common/PageTitle";
import HomeHeader from "./header/HomeHeader"; 
import DeviceUtils from "../../helper/DeviceUtils"; 
import FooterMainView from "./footer/FooterMainView";  
import ReactImageVideoLightbox from 'react-image-video-lightbox';
import Popup from "reactjs-popup";

import home_1 from "./images/home/home_1.png";
import home_2 from "./images/home/home_2.png";
import home_3 from "./images/home/home_3.png";
import mask from "./images/home/mask.png";
import playerIcon from "./images/home/playerIcon.png"; 
import event from "./images/home/event.png"; 

 
    
    
const H4divWrap =  styled.div` 
margin-left: auto;
    margin-right: auto;
    width: calc(100% - 190px - 190px);
    min-width: 980px; `;
 
const H4div =  styled.div` 

position: relative;
padding: 80px 0px 59px calc((100% - 980px) * 0);
left: 74px;
grid-area: 1 / 1 / 2 / 2;
justify-self: start;
align-self: start;

font-size: ${props => props.fontSize}px ;
    line-height:1em;  `;
 
const AbsoluteCenter =  styled.div` 
margin: 0;
            position: absolute;
            top: 50%;
            left: 50%;
            -ms-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);  `;


const RowWrap =  styled.div` 
    position:relative;
    overflow: hidden;
    height:  ${props => props.height}px;   
    width: ${props => props.width}px;  
    ;`;

const ColItemWrap =  styled.div`   
    overflow: hidden; 
    width: ${props => props.width}px; 
    height: ${props => props.width}px;   `;

const ColItem =  styled.div` 
position: absolute;
inset: 0px auto auto 0px;
margin: 0px;
cursor: pointer;
width: ${props => props.width}px; 
height: ${props => props.width}px; 
overflow: hidden;
border-radius: 0px;
border-width: 0px;
border-color: rgb(255, 255, 255);
transition: opacity 0.2s ease 0s;
opacity: 1;
display: block;
text-align: center;
`;


const InsideImg =  styled.img`  

height: ${props => props.height}px  `;


class ImgCallToAction extends Component {
        constructor(props) {
            super(props);
            this.state = { 
                isShowTitle:false,
                isOpen: false
            };
            this.openModal = this.openModal.bind(this)
        }
    
        openModal () { 
            this.setState({isOpen: true})
        }

        async componentDidMount() {
        }
    
        componentWillReceiveProps(nextProps) {
    
        }
        render() {
     
            return (
                <ColItemWrap 
                onClick={this.props.onClick} 
                className="ImgCallToAction"
                width={this.props.ImgCallToActionWidth}  
                style={{overflow:'hidden',position:'relative'}}
                 > 
                
                    <ColItem  
                    width={this.props.ImgCallToActionWidth} 
                    className="callToAction img-wrapper" 
                    onMouseEnter={() => {
                        this.setState({isShowTitle:true});
                    }}
                    onMouseLeave={() => {
                        this.setState({isShowTitle:false}); 
                    }} >

                            <div>
                                <InsideImg 
                                src={this.props.imgSrc}  
                                height={this.props.ImgCallToActionWidth}/>
                            </div>
        
                            {(this.state.isShowTitle === true ?<div  style={{position:"absolute",right:0,top:0,left:0,bottom:0  }}>
                                <InsideImg 
                                src={mask} 
                                height={this.props.ImgCallToActionWidth} />
                            </div>:null)}  

                            {(this.state.isShowTitle === true ?<div className="newpageP_b" 
                            style={{position:"absolute",left:50,bottom:50 ,fontSize:"25px"}}>
                                <b>{this.props.title}</b> 
                            </div>:null)}   

                            <AbsoluteCenter  >
                                <img src={playerIcon} style={{width:"50px",height:"50px"}} />
                            </AbsoluteCenter>

                    </ColItem>
                    
                </ColItemWrap>
                
            );
    
        }
    }

class HomePage_new extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startIndex:0,
            isOpen: false,
            RowWrapWidth:1251,
            RowWrapPaddingLeft:100,
            RowWrapCenterGap:80,
            ImgCallToActionWidth:(DeviceUtils.isMobile()===true)?window.innerWidth:((window.innerWidth - (100 + 100))-160)/2
        };
        this.videoClick = this.videoClick.bind(this)
        this.openModal = this.openModal.bind(this)
    }

    async openModal (_startIndex) { 
      await  this.setState({startIndex: _startIndex});
        this.setState({isOpen: true});
    }

    videoClick() {
    }


    componentDidMount() {

        //設定 RowWrap 寬度
        if(DeviceUtils.isMobile()===true){
            //手機
            this.setState({RowWrapWidth: window.innerWidth }); 
            //this.setState({ImgCallToActionWidth: window.innerWidth }); 
            this.setState({RowWrapPaddingLeft:0 });
            this.setState({RowWrapCenterGap:0 });  
        }else{
            //桌機
            let newRowWrapWidth = window.innerWidth - (100 + 100);
            this.setState({RowWrapWidth: newRowWrapWidth}); 
           // this.setState({ImgCallToActionWidth: (newRowWrapWidth-100)/2 });  
        }
    }

    componentWillReceiveProps(nextProps) {

    }
    render() { 

        return (
            <div id={"HomePage"} className="overflow-hidden"
                 style={{backgroundColor:'#000000',width:`${window.innerWidth}px`,color:"white"}}  >
 
                {/* <ModalVideo 
                     channel='youtube' 
                     allowFullScreen={true}
                     isOpen={this.state.isOpen} 
                     videoId='L61p2uyiMSo' 
                     onClose={() => this.setState({isOpen: false})} /> */}

                     <Popup
                            open={this.state.isOpen}
                            modal
                            closeOnDocumentClick
                            onClose={()=>{
                                this.setState({isOpen: false})
                            }}
                            contentStyle={{width:'600px',padding:'20px'}}
                        >
                            <ReactImageVideoLightbox
                                data={[  
                                    {
                                    url: "http://104.237.55.12/home_video/TWDrink_sub.mp4",
                                    type: "video",
                                    title: "Taiwan Food note : 01",
                                    },  
                                    {
                                    url: "http://104.237.55.12/home_video/BreakfastTW_sub.mp4",
                                    type: "video",
                                    title: "Taiwan Food note : 02",
                                    },  
                                    {
                                    url: "http://104.237.55.12/home_video/Beefnoodles_sub.mp4",
                                    type: "video",
                                    title: "Taiwan Food note : 03",
                                    },  
                                ]}
                                startIndex={this.state.startIndex}
                                showResourceCount={true}
                                onCloseCallback={()=>{
                                    this.setState({isOpen: false})
                                }}
                                onNavigationCallback={(currentIndex) =>{
                                    console.log(`Current index: ${currentIndex}`)
                                    this.setState({isOpen: false})
                                }}
                            />

                        </Popup> 


                {/* <MainImage src={bgLine}    className={(DeviceUtils.isMobile()===true)?"position-absolute  ":"position-absolute w-100 "} /> */}

                <div style={{position:'fixed',top:'0px',width:`${window.innerWidth}px`,zIndex:'500'}}>
                    <HomeHeader/>
                </div>

                <FadeIn> 


                    {(DeviceUtils.isMobile()===true)?
                    <div 
                    className="pl-3 pb-3"
                        style={{fontFamily: 'oswald-medium,oswald,sans-serif',   
                            fontFamily: "oswald-medium, oswald, sans-serif",
                            marginTop: "120px",
                            fontSize:`35px`}}   >
                                            SubPro<br/>
                                            Studio<br/>   
                            <p className="newpageP pt-4" style={{
                                width:`${(DeviceUtils.isMobile()===true)?window.innerWidth-80:479}px`,
                                fontSize:`${(DeviceUtils.isMobile()===true)?16:18}px`}}>
                                The expert to provide you with the services of subtitling.
                            </p>
                        </div>:<H4divWrap>
                        <H4div className="mt-5 "  
                        style={{fontFamily: 'oswald-medium,oswald,sans-serif'}} fontSize={(DeviceUtils.isMobile()===true)?35:90} >
                                            SubPro<br/>
                                            Studio<br/>   
                            <p className="newpageP pt-4" style={{
                                width:`${(DeviceUtils.isMobile()===true)?window.innerWidth-80:479}px`,
                                fontSize:`${(DeviceUtils.isMobile()===true)?16:18}px`}}>
                                The expert to provide you with the services of subtitling.
                            </p>
                        </H4div>  
                    </H4divWrap>}
 
 {(DeviceUtils.isMobile()===true)? <Container>
                            <Row className="mb-2">
                                <ImgCallToAction 
                                    onClick={()=>{
                                        this.openModal(0);
                                    }} 
                                    ImgCallToActionWidth={this.state.ImgCallToActionWidth}
                                    imgSrc={home_1} title={"Taiwan Food note : 01"} />
                            </Row>
   
                            <Row className="mb-2">
                                <ImgCallToAction 
                                    onClick={()=>{
                                        this.openModal(1);
                                    }} 
                                    ImgCallToActionWidth={this.state.ImgCallToActionWidth}
                                    imgSrc={home_2} 
                                    title={"Taiwan Food note : 02"} />  
                            </Row>

                            <Row>
                                <ImgCallToAction  
                                    onClick={()=>{
                                        this.openModal(2);
                                    }} 
                                    ImgCallToActionWidth={this.state.ImgCallToActionWidth}
                                    imgSrc={home_3} 
                                    title={"Taiwan Food note : 03"} />  
                            </Row>
    

    
 </Container>:<div>
 <RowWrap 
                    width={this.state.RowWrapWidth} 
                    height={this.state.ImgCallToActionWidth} 
                    paddingLeft={this.state.RowWrapPaddingLeft}>
                            <div 
                                style={{ 
                                    marginLeft:`${(DeviceUtils.isMobile()===true)?0:100}px`,
                                    marginRight:`${(DeviceUtils.isMobile()===true)?0:80}px`,
                                    position:'relative',
                                    float:'left',
                                    overflow:'hidden',
                                    width:`${this.state.ImgCallToActionWidth}px`,
                                    height:`${this.state.ImgCallToActionWidth}px`,
                                    maxWidth:`${this.state.ImgCallToActionWidth}px`}}>

                                        <ImgCallToAction 
                                            onClick={()=>{
                                                this.openModal(0);
                                            }}  
                                            ImgCallToActionWidth={this.state.ImgCallToActionWidth} 
                                            imgSrc={home_1} title={"Taiwan Food note : 01"} />
                                </div> 
                                <div  
                                    className=" " 
                                    style={{
                                        top:0,
                                        right:0,
                                        position:'absolute', 
                                        overflow:'hidden',
                                        width:`${this.state.ImgCallToActionWidth}px`,
                                        height:`${this.state.ImgCallToActionWidth}px`,
                                        maxWidth:`${this.state.ImgCallToActionWidth}px`}}> 
                                        
                                    <ImgCallToAction 
                                        onClick={()=>{
                                            this.openModal(1);
                                        }} 
                                                            ImgCallToActionWidth={this.state.ImgCallToActionWidth}
                                                            imgSrc={home_2} 
                                                            title={"Taiwan Food note : 02"} />  
                                </div>
                    </RowWrap>


                    <RowWrap 
                    style={{marginTop:"60px"}}
                    width={this.state.RowWrapWidth} 
                    height={this.state.ImgCallToActionWidth} 
                    paddingLeft={this.state.RowWrapPaddingLeft}>
                            <div 
                                style={{ 
                                    marginLeft:'100px',
                                    marginRight:'80px',
                                    position:'relative',
                                    float:'left',
                                    overflow:'hidden',
                                    width:`${this.state.ImgCallToActionWidth}px`,
                                    height:`${this.state.ImgCallToActionWidth}px`,
                                    maxWidth:`${this.state.ImgCallToActionWidth}px`}}>

                                        <ImgCallToAction  
                                            onClick={()=>{
                                                this.openModal(2);
                                            }} 
                                                    ImgCallToActionWidth={this.state.ImgCallToActionWidth}
                                                    imgSrc={home_3} 
                                                    title={"Taiwan Food note : 03"} />  
                                </div> 
                                <div  
                                    className=" " 
                                    style={{
                                        top:0,
                                        right:0,
                                        position:'absolute', 
                                        overflow:'hidden',
                                        width:`${this.state.ImgCallToActionWidth}px`,
                                        height:`${this.state.ImgCallToActionWidth}px`,
                                        maxWidth:`${this.state.ImgCallToActionWidth}px`}}> 
                                        
                                     
                                </div>
                    </RowWrap>

</div>}
                    

                    
                    
     

                   {/* <PageTitle title="Coming Up Events . . ." />
                    
                   <Container> 
                        <img src={event} width={(DeviceUtils.isMobile()===true)?window.innerWidth:"982" }/>
                   </Container>  */}
                </FadeIn> 

                <FooterMainView/>
            </div>
        );

    }
}


HomePage_new.propTypes = {
};

const mapStateToProps = state => ({
});

export default connect(mapStateToProps, {   })(
    withRouter(HomePage_new)
);



// WEBPACK FOOTER //
// ./src/components/homepage_new/HomePage_new.js